import styled from 'styled-components'
import { theme } from '../../../../../styles/theme'

export const Container = styled.div`
`

export const Header = styled.div`
  padding: 22px 35px;

  border-bottom: 1px solid #E7E8FC;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`

export const Wrapper = styled.div`
  padding: 24px;
`

export const InputWrapper = styled.div`
  height: 48px;
  width: 350px;
  padding: 0px 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
  border: 1px solid #A0A5B6;
  background: ${theme.colors.mainBg};
  overflow: hidden;
`

export const Input = styled.input`
  width: 100%;
  height: 100%;
  margin-left: 10px;

  border: none;
  font-family: ${theme.font.inter};
  font-size: ${theme.font.sizes.medium};
  line-height: 125%;
  color: ${theme.colors.brown};
`

export const NewProductButton = styled.button`
  height: 48px;
  padding: 12px 35px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.colors.green};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.normal};
  font-family: ${theme.font.inter};
  font-size: ${theme.font.sizes.medium};
  line-height: 125%;
  color: ${theme.colors.mainBg};

  transition: filter 300ms;

  &:hover {
    filter: brightness(0.85);
  }

  & > svg {
    width: 20px;
    margin-right: 15px;

    & > path {
      fill: ${theme.colors.mainBg};
    }
  }
`
